import { Injectable } from '@angular/core';
import { ModeModelBase } from '../model';
import { ModelAccessorBase, ModelAccessorInjectables } from '../model_accessor';

export class ReportThemeModel extends ModeModelBase {
  override _name = 'reportTheme';

  // Added by ModeModelBase
  css_href: any;
  css_source: any;

  override belongsTo = 'report';
  override parentIdAttribute = 'token';
  override attributes = [
    { name: 'css_href', default: '' },
    { name: 'css_source', default: '' },
  ];
  toJSON() {
    return {
      css_href: this.css_href,
      css_source: this.css_source,
    };
  }
}

@Injectable({ providedIn: 'root' })
export class ReportThemeModelAccessor extends ModelAccessorBase<ReportThemeModel> {
  override name = 'reportTheme';
  override parentModel = 'report';
  override parentIdAttribute = 'token';

  constructor(injectables: ModelAccessorInjectables) {
    super(injectables, 'migrated', 'mode.reportTheme');
  }

  override createModel(resource, opts?) {
    const model = new ReportThemeModel(this.injectables.modelInjectables);
    model.$initialize(resource, opts);
    return model;
  }
}
